/**
* @ngdoc service
* @name help.service:helpService
* @requires common.service:ItxLoaderFct
* @requires common.service:cmsService
* @description
* Due to the strongs limitations of the CMS its necessary to do some logic in the front
*/
(function() {
    'use strict';

    angular
    .module('itxApp.help')
    .service('helpService', helpService);

    helpService.$inject = [
        '$q',
        '$state',
        'ItxLoaderFct',
        'cmsService'
    ];

    function helpService (
        $q, 
        $state,
        ItxLoaderFct,
        cmsService
    ) {
        var _this = this;

        // Menu model
        _this.menu = {
            title: '',
            items: []
        };
        // Breadcrumb model
        _this.breadcrumb = {
            submenu: {},
            content: ''
        };        

        // JSON file prefix for faqs.
        var filePrefixNew = 'faqs_section_';

        var service =  {
            getMenu: getMenu,
            getSubmenu: getSubmenu,
            getHelpContent: getHelpContent,
            getBreadcrumb: getBreadcrumb,
            getIconPath: getIconPath,
            cleanCovid: cleanCovid
        };

        return service;

        function cleanCovid(){
            var deferred = $q.defer();
            $('#help-page-main').removeClass('covid-19');
            deferred.resolve();
            return deferred.promise;
        }

        /**
        * @ngdoc method
        * @name getMenu
        * @methodOf help.service:helpService
        * @returns {promise} menu object promise
        * @description
        * Returns the menu. If menu has been previously loaded, then return it from local service variable.
        */
        function getMenu(){
            var deferred = $q.defer();
            
            ItxLoaderFct.show();

            if(_this.menu.items.length>1){
                ItxLoaderFct.hide();
                deferred.resolve(_this.menu);
                return deferred.promise;
            }

            cmsService.getContent('faqs_main')
            .then(function (res) {
                var elems = _extractMenuElements(res[0].layout.children);
                _setMenuNew(elems);
                deferred.resolve(_this.menu);
            })
            .catch(function (error) {
                deferred.resolve(error);
            })
            .finally(function(){
                ItxLoaderFct.hide();
            });
            return deferred.promise;
        }

        /**
        * @ngdoc method
        * @name _setMenu
        * @private
        * @methodOf help.service:helpService
        * @param {array} widgets Array of items
        * @description
        * Set menu title, items and links.
        * As convention, the menu title will be the first item of the array of widgets.
        */
        function _setMenu(widgets){
            _this.menu.title = widgets[0].text;
            _this.menu.items = _.drop(widgets); // Drop the first element of the array.
            _this.menu.items = angular.forEach(_this.menu.items, function(item){
                item.link = cmsService.getLink(item.text);
            });
        }

          /**
        * @ngdoc method
        * @name _setMenu
        * @private
        * @methodOf help.service:helpService
        * @param {array} widgets Array of items
        * @description
        * Set menu title, items and links.
        * As convention, the menu title will be the first item of the array of widgets.
        */
       function _setMenuNew(widgets){
        _this.menu.title = widgets[0].text;
        _this.menu.items = _.drop(widgets); // Drop the first element of the array.
        _this.menu.items = angular.forEach(_this.menu.items, function(item){
            item.link = item.name;
            //item.link = cmsService.getLink(item.text);
        });
    }
        /**
        * @ngdoc method
        * @name getSubmenu
        * @methodOf help.service:helpService
        * @param {string} submenuName submenu description
        * @returns {promise} Object promise with submenu information
        * @description
        * Get submenu object information to resolve the route and pass it to the {@link help.component:itxHelpSubmenu itxHelpSubmenu} component.
        * The submenu parameter must match with the generated file by the CMS.
        */
        function getSubmenu(submenuName){

            var deferred = $q.defer();

            if(_this.submenu && _this.submenu.name == submenuName){
                deferred.resolve(_this.submenu);
                return deferred.promise;
            }

            ItxLoaderFct.show();
            
            cmsService.getContent(filePrefixNew + submenuName)
            .then(function (res) {
                
                _this.widgets= _extractMenuElements( res[0].layout.children);
                _setSubmenuWidget(_this.widgets,submenuName);
                _setBreadcrumb(submenuName);
                deferred.resolve(_this.submenu);
            })
            .catch(function (error) {
                $state.go('main');
                deferred.reject(error);
            }).finally(function(){
                ItxLoaderFct.hide();
            });

            return deferred.promise;
        }

        /**
        * @ngdoc method
        * @name _setSubmenuWidget
        * @private
        * @methodOf help.service:helpService
        * @param {array} data widget object
        * @description
        * Set the submenu widget object
        */
        function _setSubmenuWidget (widgets,submenuName){
            
            _this.submenu =  _.find(widgets, function(widget) { return  widget.name == 'submenu'; });
            _this.submenu.title = widgets[0];
            _this.submenu.name= submenuName;
        }
        /**
        * @ngdoc method
        * @name getHelpContent
        * @methodOf help.service:helpService
        * @param {string} submenu submenu name. Example:`returns`
        * @param {string} content content name  Exampl: `return-process`
        * @returns {promise} widget object promise
        * @description
        * Get help content data
        */
        function getHelpContent(submenu, content){
       
            var deferred = $q.defer();
            
            if(_this.content && _this.content.name == content){
                deferred.resolve(_this.content);
                return deferred.promise;    
            }            
            
            ItxLoaderFct.show();

            getSubmenu(submenu)
            .then(function(){
                
                // var widgets = data.text.blocks;
              
                _this.content = _.find(_this.widgets, function(widget) { return  widget.name == content; });
                
                if(_this.content){
                    _this.content.title= _getHelpContentTitle(_this.widgets,content);
                    _this.breadcrumb.content =  _this.content.title;
                }                

                deferred.resolve(_this.content);
            })
            .catch(function (error) {
                $state.go('main');
                deferred.reject(error);
            }).finally(function(){
                ItxLoaderFct.hide();
            });

            return deferred.promise;
               }


        /**
        * @ngdoc method
        * @name _getHelpContentTitle
        * @private
        * @methodOf help.service:helpService
        * @description
        * Get the content title 
        */
        function _getHelpContentTitle(widgets,content){

             var submenu = _this.submenu.text;

            for(var idx=0; idx<submenu.blocks.length;idx++){
                if(!submenu.blocks[idx].entityRanges || typeof submenu.blocks[idx].entityRanges != 'object' || submenu.blocks[idx].entityRanges.length<1){
                    continue;
                }
                
                var linkKey = submenu.blocks[idx].entityRanges[0].key;
                
                if(submenu.entityMap[linkKey].data.src == content){
                    return submenu.blocks[idx].text;
                }
            }
            return '';    
        }
        /**
        * @ngdoc method
        * @name getBreadcrumb
        * @methodOf help.service:helpService
        * @returns {object} breadcrumb object
        * @description
        * Get breadcrumb object with texts of submenu and content.
        */
        function getBreadcrumb(){
            return _this.breadcrumb;
        }
        /**
        * @ngdoc method
        * @name _setBreadcrumb
        * @private
        * @methodOf help.service:helpService
        * @description
        * Set submenu text and link
        */
        function _setBreadcrumb(submenu){
            if(submenu){
                _this.breadcrumb.submenu.text = _this.submenu.title.text.blocks[0].text;
                _this.breadcrumb.submenu.link = submenu;
            }
        }
        /**
        * @ngdoc method
        * @name getIconPath
        * @private
        * @methodOf help.service:helpService
        * @description
        * Given a icon name, returns the icon path to the file.
        * @param {string} inconName icon name
        */
        function getIconPath(iconName){
            return 'faqs/'+ iconName.toLowerCase()+'.png';
        }
        function _extractMenuElements(childs){
            var to_return = [];
            
            for (var a = 0; a< childs.length;a++){
                var child = childs[a];
                if(child.internalType === 'piece-text'){

                    to_return.push(child);
                }
                else{
                    var result = _extractMenuElements(child.children);
                    
                    to_return = _.concat(to_return,result);
                }
            }
            return to_return;
        }
    }

})();